import { render, staticRenderFns } from "./DragDrop.vue?vue&type=template&id=533310f0&"
import script from "./DragDrop.vue?vue&type=script&lang=js&"
export * from "./DragDrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports